export * from "./StandardProductDetailsContainer";
